import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppAccessControlService} from './app-access-control.service';

@Directive({
	standalone: true,
	selector: '[appIsGranted]',
})
export class AppIsGrantedDirective implements OnDestroy {
	private readonly destroy$ = new Subject<void>();
	private hasView = false;

	constructor(
		private templateRef: TemplateRef<unknown>,
		private viewContainer: ViewContainerRef,
		private accessChecker: AppAccessControlService,
	) {}

	@Input()
	set appIsGranted([permission, resource]: [string, string]) {
		this.accessChecker.isGranted(permission, resource)
			.pipe(takeUntil(this.destroy$))
			.subscribe(can => {
				if (can && !this.hasView) {
					this.viewContainer.createEmbeddedView(this.templateRef);
					this.hasView = true;
				} else if (!can && this.hasView) {
					this.viewContainer.clear();
					this.hasView = false;
				}
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
